import { convertDate, convertHours } from "../utils/dateConverter";

export const formatListeningDateTime = (value) => {
  if (!value) {
    return "-";
  }

  return `${convertDate(value)} ${convertHours(value)}`.trim();
};

export const formatListeningNumber = (value, digits = 2) => {
  if (value == null || Number.isNaN(Number(value))) {
    return "-";
  }

  return Number(value).toFixed(digits);
};

export const formatListeningNumberWithUnit = (
  value,
  unit = "dB",
  digits = 2,
) => {
  const formatted = formatListeningNumber(value, digits);
  return formatted === "-" ? "-" : `${formatted} ${unit}`;
};

export const formatListeningCreatedBy = (value) => value || "-";

export const formatListeningLocation = (value) => value || "-";

export const formatListeningDescription = (value) => value || "-";

export const formatListeningDeviceId = (value) => value || "-";

export const sortListeningFrequencies = (values = []) =>
  [
    ...new Set(
      (values || []).map(Number).filter((value) => !Number.isNaN(value)),
    ),
  ].sort((a, b) => a - b);

export const getListeningCurrentLabel = (current) => {
  if (current === true) {
    return "Aktualny";
  }

  if (current === false) {
    return "Nieaktualny";
  }

  return "-";
};

export function getListeningCurrentColor(current) {
  if (current === true) {
    return "#5c6bc0";
  }

  if (current === false) {
    return "#90a4ae";
  }

  return "#9e9e9e";
}
